export enum RouteNames {
  ROOT = 'root',
  BOARD = 'board',
  CARD = 'card',
  SEARCH = 'search',
  SHORTCUTS = 'shortcuts',
  POWER_UPS = 'power-ups',
  UNKNOWN = 'unknown',
}
